import { render } from "./AppPrivacyOverview.vue?vue&type=template&id=ba2a5782&ts=true"
import script from "./AppPrivacyOverview.vue?vue&type=script&lang=ts"
export * from "./AppPrivacyOverview.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__